export default __webpack_public_path__ + "static/media/convertshape-2.730cf7ab.svg";